export const SET_CUSTOMER = "SET_CUSTOMER";

export const set_customer_action = (data) => {
  return {
    type: SET_CUSTOMER,
    payload: data,
  };
};
